import types from 'constants/actionTypes';

import { combineReducers } from 'redux';
 
const initialState = {

  totalInCart: null,

  remaining: null,

};
 
const totalInCart = (state = initialState.totalInCart, action) => {

  const { type, payload } = action || {};
 
  switch (type) {

    case types.GET_TOTAL_CART_QUANTITY_REQUEST_SUCCESS:

      return payload?.totalInCart ?? state;

    default:

      return state;

  }

};
 
const remaining = (state = initialState.remaining, action) => {

  const { type, payload } = action || {};
 
  switch (type) {

    case types.GET_ADDITIONAL_CART_REQUEST_SUCCESS:
//falls through
    case types.GET_CART_REQUEST_SUCCESS:

      return payload?.result?.remainingSeries ?? state;

    default:

      return state;

  }

};
 
export default combineReducers({

  totalInCart,

  remaining,

});
 
